const removeUrlPath = (url: string) => {
    const urlParts = url.split('/');
    return `${urlParts[0]}//${urlParts[2]}`;
};

export { removeUrlPath };
